import elementStateToggle from '../../../../../../src24/js/modules/elementStateToggle';

window.addEventListener('load', () => {
    elementStateToggle.init({
        hasContextElement: {
            elements: '.js-state-context',
            attr: 'href',
        },
        scrollToTrigger: true,
        offset: -200,
        toggleActiveElement: true,
        removeAllActiveClasses: true,
    });
}, false);
